import React, { memo } from 'react';
import { ScrollView } from 'react-native';
/**
 * Primary UI component for user interaction
 */
const ScrollStack = ({ width, widgetItems, renderItem }) => {
    const content = (renderItem && widgetItems && widgetItems.map(renderItem));
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollView, { showsHorizontalScrollIndicator: false, horizontal: true, style: { width: width ? width : '100%' } }, content)));
};
export default memo(ScrollStack);
export { ScrollStack };
